module.exports = __webpack_public_path__ + "static/img/19051C_2_R_20200721_LC.afc4fd9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/19051C_2_R_20200721_LC.png
// module id = 0jWg
// module chunks = 0